var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-modal"},[_c('div',{staticClass:"background"}),_vm._v(" "),_c('div',{staticClass:"modal"},[_c('div',{ref:"header",staticClass:"header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{ref:"body",staticClass:"body"},[_vm._t("body")],2),_vm._v(" "),_c('div',{ref:"footer",staticClass:"footer"},[_vm._t("footer")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b2b534","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Modal/Index.vue
// module id = null
// module chunks = 